export enum TrialRequestTextElement {
  Login = 'Already have an account?',
}
